import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const c = e(
  (r, t) => /* @__PURE__ */ o.jsx(
    i,
    {
      ref: t,
      ...r,
      image: (s) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...s,
          children: /* @__PURE__ */ o.jsx("circle", { cx: 8, cy: 8, r: 3, fill: "currentColor" })
        }
      )
    }
  )
);
c.displayName = "DotIcon";
export {
  c as DotIcon,
  c as default
};
//# sourceMappingURL=index.js.map
